import PageMeta from '../components/seo/PageMeta';
import LegalPage from '../components/layout/LegalPage';
import { SUPPORT_URL } from '../constants';

export default function PrivacyPage() {
  return (
    <>
      <PageMeta
        title="Privacy Policy | PixelUtility QR"
        description="Privacy policy for the PixelUtility free QR code generator."
        path="/privacy"
      />
      <LegalPage title="Privacy Policy">
        <p>
          PixelUtility QR is designed to generate QR codes in your browser. We do not
          require account registration to use the generator.
        </p>
        <h2 className="mt-8 text-xl font-semibold text-slate-900">Data we process</h2>
        <p className="mt-3">
          Content you enter to create a QR code is processed locally in your browser
          for generation and preview. We do not intentionally collect or store the
          payload of your QR codes on our servers as part of the generation flow.
        </p>
        <h2 className="mt-8 text-xl font-semibold text-slate-900">Analytics</h2>
        <p className="mt-3">
          We may use privacy-conscious analytics to understand aggregate usage (such as
          page views and download events). You can control cookies through your browser
          settings where applicable.
        </p>
        <h2 className="mt-8 text-xl font-semibold text-slate-900">Support</h2>
        <p className="mt-3">
          Questions about this policy? Visit our{' '}
          <a
            href={SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-indigo-600 hover:text-indigo-700"
          >
            support page
          </a>
          .
        </p>
      </LegalPage>
    </>
  );
}
